import { useMutation } from "react-query"

interface OpenAIResponse {
  choices: {
    message: {
      content: string
    }
  }[]
}

interface OpenAIRequest {
  query: string
}

// Function to make a direct request to OpenAI API
const callOpenAI = async (request: OpenAIRequest): Promise<{
  answer: string
  file_path?: string
  filename?: string
}> => {
  const openaiApiKey = process.env.REACT_APP_OPENAI_API_KEY
  
  if (!openaiApiKey) {
    throw new Error("OpenAI API key is not set in environment variables")
  }

  const response = await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${openaiApiKey}`
    },
    body: JSON.stringify({
      model: "gpt-4o",
      messages: [
        {
          role: "system",
          content: `Ты Q&A ассистент в управляющей компании, отвечаешь на вопросы жителей которые используют приложение Домиленд
            
            Вот твоя база знаний. Это список вопросов и ответов с примером текста заявки:

            <База знаний>
            1. **Вопрос**: Почему пропуск на машину отменяют регулярно?  
            **Пример текста заявки**:  
            *Собственник. Клиент сообщает, что оформляет пропуск на машину Мерседес A088AK550, но пропуск 3 раза был отменён. Клиент уточняет, почему пропуск отменяют регулярно. Необходимо предоставить обратную связь.*  
            **Ответ**: В соответствии с установленным порядком пользования подземным паркингом для допуска сторонних транспортных средств на временную стоянку необходимо подать заявку в Приложении Домиленд, либо через колл-центр, либо непосредственно в клиентском офисе на пропуск с указанием следующих сведений с указанием следующих данных:
            - Марка, номер и тип транспортного средства;
            - Цель визита (гостевой, доставка, вывоз);
            - Номер или статус машиноместа.
            
            ЗАЯВКИ, СОСТАВЛЕННЫЕ С НАРУШЕНИЕМ ДАННОЙ ФОРМЫ, ПРИНИМАТЬСЯ НЕ БУДУТ

            2. **Вопрос**: Как можно прикрепить дополнительный номер телефона арендатора для доступа к приложению Домиленд?  
            **Пример текста заявки**:  
            *Как можно прикрепить дополнительный номер телефона арендатора для доступа к этой программе, чтобы она, например, оставляла заявки на пропуск гостей и доставку?*  
            **Ответ**: Для добавления пользователя в мобильное приложение, нужно выбрать раздел "Дом" в нижней части экрана, далее выбрать раздел "Люди", нажать на кнопку "+", и ввести данные арендатора (ФИО, номер телефона, роль).

            3. **Вопрос**: Почему показания счетчиков не отправляются автоматически?  
            **Пример текста заявки**:  
            *Добрый день. 23.12.24 поменяли счётчик отопления. В январе показания внесли вручную. Здесь в обращении отвечали, что нужно будет 1 раз внести, и дальше будут показания передаваться автоматически. Сейчас март, а в приложении указано, что показания счётчика отопления последний раз были внесены в январе. Получается, что автоматически не отправились показания за февраль? Как теперь будут начисления? Как сделать, чтобы показания передавались автоматически?*  
            **Ответ**: Доступ в личный кабинет для передачи показаний по счетчикам — это дополнительная опция в работе приложения от управляющей компании. Ее можно включить в настройках приложения: вкладка “дом” → “настройки” → “показания счетчиков”.

            4. **Вопрос**: Как осуществить поверку счетчиков электроэнергии?  
            **Пример текста заявки**:  
            *Обращается собственник, просит уточнить, как осуществить поверку счетчиков электроэнергии. Нужна обратная связь.*  
            **Ответ**: Для замены требуется приобрести счетчик Меркурий 230 ART-01 СN, Трёхфазный, Многотарифный, 3x230/400В, 5 (60)А 50 Гц, Интерфейсы: CAN, RS-485. Стоимость замены без стоимости счетчика составляет 4620 руб. После приобретения счетчика создайте заявку в ЛК с указанием, что приобрели счетчик и требуется его замена. После оплаты счета в ЛК с вами свяжется техник и согласует время работы.

            5. **Вопрос**: Какая длительность гарантии на сантехнические работы?  
            **Пример текста заявки**:  
            *Обращается собственник, хочет уточнить, какая длительность гарантии на сантехнические работы мастера в его квартире. Нужна обратная связь.*  
            **Ответ**: Гарантия на сантехнические работы составляет 3 месяца.  

            </База знаний>

            Отвечай на вопрос используя занания только из Базы знаний. Если знания нет - скажи что пока не можешь ответить на этот вопрос, но скоро научишься
            Если тебе пишут не просто вопрос а формулировку заявки в которой содержится вопрос - ответь на него 

            Пример заявки ответа на которую у тебя нет в Базе знаний
            **Пример текста заявки**: "С чем связано обращение?: Работа приложения; Комментарий: Обратился собственник. Клиент сообщает, что ему заблокировали доступ в приложение в связи с нарушением правил парковки, хотя по факту автомобиль просто остановился возле лифта, была произведена быстрая разгрузка и автомобиль сразу же переставили. Просьба срочно решить данную проблему. Связь 9250063036 Светлана;"
            **Пример твоего ответа**: "Пока не могу помочь с решением этого вопроса, но скоро научусь"
          `
        },
        {
          role: "user",
          content: request.query
        }
      ],
      temperature: 0.7
    })
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`OpenAI API error: ${error}`)
  }

  const data = await response.json() as OpenAIResponse
  
  return {
    answer: data.choices[0].message.content,
    // Since we're not using files in this PoC, we leave these undefined
    file_path: undefined,
    filename: undefined
  }
}

// Custom hook to use the OpenAI API
const useOpenAIPrediction = () => {
  return useMutation(callOpenAI)
}

export { useOpenAIPrediction } 